module.exports = __webpack_public_path__ + "static/media/proicons_cookies.cf20d41e.svg";